import React, { useCallback, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useDropzone } from 'react-dropzone'

function UploadProfileImage({ handleUpload }) {
  const [invalid, setInvalid] = useState(false)
  const [attachments, setAttachments] = useState([]);

  const onDrop = useCallback(acceptedFiles => {
    setInvalid(false)

    if (acceptedFiles.length === 0) {
      setInvalid(true)
    } else {
      setAttachments(acceptedFiles);
      
      const reader = new FileReader()
  
      reader.onloadend = () => {
        handleUpload(reader.result);
      }
      
      reader.onerror = (error) => {
        setInvalid(true)
      }

      reader.readAsDataURL(acceptedFiles[0])
    }
  }, [handleUpload]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: 'image/png, image/jpeg'
  });

  const removeFile = (removeIndex) => {
    const acceptedFiles = attachments.filter((attachment, index) => removeIndex !== index);

    setAttachments(acceptedFiles);
  };

  return <>
    {invalid && <Alert variant='danger'>Invalid File Type</Alert>}
    {attachments.length === 0 &&
      <div {...getRootProps()} 
        style={{border: '1px solid #1AB2E9'}}
        className="bg-light py-4 text-center font-weight-light axs-rounded"
      >
        <input {...getInputProps()} />
        {
          isDragActive ?
            <p className="m-0">Drop the files here ...</p> :
            <>
              <p><i className="fas fa-cloud-upload-alt fa-lg" style={{color: '#1AB2E9'}}></i></p>
              <p>Click to upload or drag and drop</p>
              <p className='text-muted m-0'>PNG or JPG images</p>
            </>

        }
      </div>
    }

    {attachments.map((file, index) => {
      return <p key={index}>
        <a href="!#" className="btn btn-link" onClick={(e) => { 
          e.preventDefault();

          handleUpload(null);
          removeFile(index)
        }}>Remove</a>
      </p>
    })}
  </>
}

export default connect()(UploadProfileImage);